import { PropTypes } from "prop-types";
import { StyledField } from "../../../styles/StyledField";
import { Select } from "../../Select";
import { useEffect, useState } from "react";
import { StyledDirectionForm, StyledSelectableDirectionType } from "../../../styles/StyledDecision/StyledContent";
import { StyledModalFooterActions } from "../../../styles/StyledAddUpperDecision";
import { Button } from "../../Button";
import AddIcon from "../../../assets/img/icons/add.svg";
import { useQuery } from "react-query";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { getAvailableDecisions, getDirectionMembersList, getDirectionUnitsList } from "../../../api/decision/directions";
import { Search } from "../../Search";
import { SelectableSingleUnits } from "../../SelectableLists/SelectableUnits";
import { SelectableSinglePeople } from "../../SelectableLists/SelectablePeople";
import { SelectableSingleDecision } from "../../SelectableLists/SelectableDecisions";
import { getUsers } from "../../../api/admin/user";
import { getUserProfile } from "../../../api/user/profile";

export default function AddDirection({ directionData, editedDirections, updateDirections, editedId, closeModal }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [editSet, setEditSet] = useState(false);
	const [order, setOrder] = useState(directionData.length + 1);
	const [currentUser, setCurrentUser] = useState(null);
	const [allUsers, setAllUsers] = useState([]);

	const [description, setDescription] = useState("");

	const [type, setType] = useState(null);

	const [url, setUrl] = useState("");
	const [urlLabel, setUrlLabel] = useState("");
	const [currentUserId, setCurrentUserId] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const userProfile = await getUserProfile(axiosPrivate);
				setCurrentUser(userProfile);

				if (userProfile.isAdmin) {
					const usersList = await getUsers(axiosPrivate);
					setAllUsers(usersList);
				}
			} catch (err) {
				console.error("Failed to fetch user data:", err);
			}
		};

		fetchData();
	}, []);

	const [responsibilityType, setResponsibilityType] = useState("member");
	const [phrase, setPhrase] = useState(null);
	const { isLoading, isError, error, data } = useQuery(["responsibility", phrase, type, responsibilityType], () => {
		if (type?.value === "decision" || type === "decision") {
			return getAvailableDecisions(axiosPrivate);
		} else if ((type?.value === "responsible" || type === "responsible") && responsibilityType === "member") {
			return getDirectionMembersList(axiosPrivate, phrase);
		} else {
			return getDirectionUnitsList(axiosPrivate, phrase);
		}
	});

	const [memberId, setMemberId] = useState(null);
	const [unitId, setUnitId] = useState(null);
	const [decision, setDecision] = useState();

	useEffect(() => {
		if (isError) console.log(error);

		if (editedId && !editSet) {
			let tempOrder;

			const temp = editedDirections.filter((e, i) => {
				if (parseInt(e.id) === parseInt(editedId)) tempOrder = i;
				return parseInt(e.id) === parseInt(editedId);
			});
			const editedDirection = temp[0];

			setOrder(tempOrder);
			setDescription(editedDirection.description);

			if (editedDirection?.url) {
				setType("url");
				setUrl(editedDirection.url);
				setUrlLabel(editedDirection.urlLabel);
			} else if (editedDirection?.followDecision) {
				setType("decision");
				setDecision(editedDirection.followDecision.id.toString());
			} else if (editedDirection?.responsibleUser) {
				setType("responsible");
				setResponsibilityType("member");
				setMemberId(editedDirection.responsibleUser.id.toString());
			} else if (editedDirection?.responsibleUnit) {
				setType("responsible");
				setResponsibilityType("unit");
				setUnitId(editedDirection.responsibleUnit.id.toString());
			} else {
				setType(null);
			}

			setEditSet(true);
		}
	}, [directionData, editedId]);

	// const onChangeValue = (event) => {
	// 	setDecision(event.target.value);
	// };

	const changeDescriptionHandler = (e) => {
		setDescription(e.target.value);
	};

	const handleUpdate = () => {
		// Ensure description is not empty
		if (!description || description.trim() === "") {
			alert("Description is required");
			return;
		}

		const resultDirection = { description: description.trim() };
		let res;

		if (type === "responsible") {
			if (responsibilityType === "member") {
				resultDirection.responsibleUser = memberId;
			} else {
				resultDirection.responsibleUnit = unitId;
			}
		} else if (type === "decision") {
			resultDirection.followDecision = decision;
		} else if (type === "url") {
			resultDirection.url = url;
			resultDirection.urlLabel = urlLabel;
		} else if (type === "actor") {
			resultDirection.responsibleUnit = unitId;
		}
		if (!editedId) {
			res = [...editedDirections];
			res.splice(parseInt(order) - 1, 0, resultDirection);
		} else {
			res = [];
			let oldIndex;
			editedDirections.map((e, i) => {
				if (parseInt(e.id) === parseInt(editedId)) {
					oldIndex = i;
					res.push(resultDirection);
				} else {
					res.push(e);
				}
			});

			arrayMove(res, oldIndex, parseInt(order) - 1);
		}
		updateDirections(res);
	};

	const filteredUnits = Array.isArray(data)
		? data.filter((item) => item?.createdBy === currentUser?.id)
		: [];

	const filteredDecisions = Array.isArray(data)
		? data.filter((item) => item?.createdBy === currentUser?.id)
		: [];
	
	const filteredMembers = currentUser
	? currentUser.isAdmin ? allUsers.filter((user) => user.id === currentUser.id || user.createdById === currentUser.id)
		: [currentUser]
	: [];

	return (
		<StyledDirectionForm>
			<div className="default-fields">
				<StyledField edit={true}>
					<label>Order</label>
					<Select
						options={[
							...directionData.map((el, i) => {
								return { value: i + 1, label: i + 1 };
							}),
							{ value: directionData.length + 1, label: directionData.length + 1 },
						]}
						value={order}
						setUnitData={(selectedOption) => setOrder(selectedOption.value)}
						id="order"
						name="order"
						directionData-testid="order"
					/>
				</StyledField>
				<StyledField edit={true}>
					<label>Description</label>
					<input type="text" value={description} onChange={changeDescriptionHandler} />
				</StyledField>
			</div>
			<div className="type-fields">
				<StyledField edit={true}>
					<label>Act type</label>
					<Select
						options={[
							{ value: null, label: "Information" },
							{ value: "url", label: "Link" },
							{ value: "responsible", label: "Responsible" },
							{ value: "decision", label: "Decision" },
							{ value: "actor", label: "Actor"},
						]}
						value={type}
						setUnitData={(selectedOption) => {
							const value = selectedOption?.value;
							setType(value === "null" ? null : value);
						}}
						id="type"
						name="type"
						directionData-testid="type"
					/>
				</StyledField>
				{(type === "responsible") && (
					<StyledSelectableDirectionType>
						<label>
							<input
								type="radio"
								name="directionType"
								value={"member"}
								onChange={() => setResponsibilityType("member")}
								defaultChecked={true}
							/>
							<span className="checkmark"></span>
							Member
						</label>
						<label>
							<input type="radio" name="directionType" value={"unit"} onChange={() => setResponsibilityType("unit")} />
							<span className="checkmark"></span>
							Unit
						</label>
					</StyledSelectableDirectionType>
				)}
			</div>
			{(type === "url") && (
				<div className="url-fields">
					<StyledField edit={true}>
						<label>Act</label>
						<input placeholder="Type or paste URL" type="text" value={url} onChange={(e) => setUrl(e.target.value)} />
					</StyledField>
					<StyledField edit={true}>
						<label>Link label</label>
						<input placeholder="Type link label" type="text" value={urlLabel} onChange={(e) => setUrlLabel(e.target.value)} />
					</StyledField>
				</div>
			)}
			{(type === "responsible") && (
				<div className="responsible-fields">
					<Search isWhite setPhrase={setPhrase} value={phrase} />
					{responsibilityType !== "member" && (
						<SelectableSingleUnits
							data={filteredUnits}
							isLoading={isLoading}
							isError={isError}
							error={error}
							setUnitSelectedID={(id) => setUnitId(id)}
						/>
					)}
					{responsibilityType === "member" && (
						<SelectableSinglePeople
							data={filteredMembers}
							isLoading={isLoading}
							isError={isError}
							error={error}
							setSelectedPersonID={(id) => setMemberId(id)}
						/>
					)}
				</div>
			)}
			{(type === "decision") && (
				<div className="decision-fields">
					<Search isWhite setPhrase={setPhrase} value={phrase} />
					<SelectableSingleDecision data={filteredDecisions} isLoading={isLoading} isError={isError} error={error} setSelectedDecisionID={setDecision} />
				</div>
			)}
			{(type === "actor") && (
				<div className="decision-fields">
					<Search isWhite setPhrase={setPhrase} value={phrase} />
					<SelectableSingleUnits
						data={filteredUnits}
						isLoading={isLoading}
						isError={isError}
						error={error}
						setUnitSelectedID={(id) => setUnitId(id)}
					/>
				</div>
			)}
			<StyledModalFooterActions>
				<Button onClick={() => closeModal()} bg={false} small={true}>
					cancel
				</Button>
				<Button icon={AddIcon} onClick={handleUpdate}>
					Confirm
				</Button>
			</StyledModalFooterActions>
		</StyledDirectionForm>
	);
}

AddDirection.propTypes = {
	editedDirections: PropTypes.any,
	updateDirections: PropTypes.any,
	directionData: PropTypes.any,
	editedId: PropTypes.string,
	closeModal: PropTypes.func,
};

function arrayMove(arr, old_index, new_index) {
	if (new_index >= arr.length) {
		let k = new_index - arr.length + 1;
		while (k--) {
			arr.push(undefined);
		}
	}
	arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
}
